module.exports = __webpack_public_path__ + "308a406a459290bc.svg";